'use strict';

export default {
  showPrice: true,
};



// WEBPACK FOOTER //
// ./app/src/services/listing_price.js